import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';

export const MuiBadge = {
  styleOverrides: {
    root: {
      // Base badge container styles
    },
    badge: {
      minWidth: 20,
      height: 20,
      borderRadius: 10,
      fontSize: '0.75rem',
      fontWeight: 600,
      padding: '0 6px',
    },
    dot: {
      minWidth: 8,
      height: 8,
      borderRadius: '50%',
      padding: 0,
    },
    // Standard anchor positioning (for circular avatars/icons)
    anchorOriginTopRight: {
      top: -2,
      right: -2,
    },
    anchorOriginTopLeft: {
      top: -2,
      left: -2,
    },
    anchorOriginBottomRight: {
      bottom: -2,
      right: -2,
    },
    anchorOriginBottomLeft: {
      bottom: -2,
      left: -2,
    },
    // Rectangular anchor positioning (for buttons, icons)
    anchorOriginTopRightRectangular: {
      top: 0,
      right: 0,
    },
    anchorOriginTopLeftRectangular: {
      top: 0,
      left: 0,
    },
    anchorOriginBottomRightRectangular: {
      bottom: 0,
      right: 0,
    },
    anchorOriginBottomLeftRectangular: {
      bottom: 0,
      left: 0,
    },
    // Color variants with CSS variable fallback to theme palette
    // Ensures colors resolve correctly even if CssVarsProvider is disabled
    colorPrimary: ({ theme }) => ({
      backgroundColor: theme.vars?.palette?.primary?.main ?? theme.palette.primary.main,
      color: theme.vars?.palette?.primary?.contrastText ?? theme.palette.primary.contrastText,
    }),
    colorSecondary: ({ theme }) => ({
      backgroundColor: theme.vars?.palette?.secondary?.main ?? theme.palette.secondary.main,
      color: theme.vars?.palette?.secondary?.contrastText ?? theme.palette.secondary.contrastText,
    }),
    colorError: ({ theme }) => ({
      backgroundColor: theme.vars?.palette?.error?.main ?? theme.palette.error.main,
      color: theme.vars?.palette?.error?.contrastText ?? theme.palette.error.contrastText,
    }),
    colorSuccess: ({ theme }) => ({
      backgroundColor: theme.vars?.palette?.success?.main ?? theme.palette.success.main,
      color: theme.vars?.palette?.success?.contrastText ?? theme.palette.success.contrastText,
    }),
    colorWarning: ({ theme }) => ({
      backgroundColor: theme.vars?.palette?.warning?.main ?? theme.palette.warning.main,
      color: theme.vars?.palette?.warning?.contrastText ?? theme.palette.warning.contrastText,
    }),
    colorInfo: ({ theme }) => ({
      backgroundColor: theme.vars?.palette?.info?.main ?? theme.palette.info.main,
      color: theme.vars?.palette?.info?.contrastText ?? theme.palette.info.contrastText,
    }),
  },
} satisfies Components<Theme>['MuiBadge'];
